import { type PimProductV11 } from '@redteclab/api/clients/bully'

// https://jira.shop-apotheke.com/browse/WSAWA-7394
// Whitelist of products supported by Viaslim ODS for CH.
// For now, we are enabling this feature only for this fixed set of products.
const VIASLIM_PARTNER_EANS = new Set<string>([
  '7680542820361',
  '7680542820446',
  '7680621070014',
  '7680621070021',
  '7680626630015',
  '7680626630022',
  '7680652190026',
  '7680658990033',
  '7680658990057',
  '7680666040010',
  '7680666040034',
  '7680687260015',
  '7680687260022',
  '7680687260039',
  '7680687260046',
  '7680687260053',
  '7680687260060',
  '7680687980012',
  '7680687980029',
  '7680687980036',
  '7680687980043',
  '7680687980050',
])

export const productAccessorHasViaslimOdsPartner = (
  product: PimProductV11,
): boolean => {
  if (!product.ean) {
    return false
  }

  return VIASLIM_PARTNER_EANS.has(product.ean)
}
